var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27.872 27.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_345",
    d: "M20.556,17.028A3.528,3.528,0,1,1,17.028,13.5,3.528,3.528,0,0,1,20.556,17.028Z",
    transform: "translate(-4.092 -4.092)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_346",
    d: "M23.138,17.964a1.94,1.94,0,0,0,.388,2.14l.071.071A2.353,2.353,0,1,1,20.269,23.5l-.071-.071a1.956,1.956,0,0,0-3.316,1.388v.2a2.352,2.352,0,0,1-4.7,0v-.106a1.94,1.94,0,0,0-1.27-1.776,1.94,1.94,0,0,0-2.14.388L8.7,23.6a2.353,2.353,0,1,1-3.328-3.328L5.44,20.2a1.956,1.956,0,0,0-1.388-3.316h-.2a2.352,2.352,0,0,1,0-4.7h.106a1.94,1.94,0,0,0,1.776-1.27,1.94,1.94,0,0,0-.388-2.14L5.275,8.7A2.353,2.353,0,1,1,8.6,5.369l.071.071a1.94,1.94,0,0,0,2.14.388h.094a1.94,1.94,0,0,0,1.176-1.776v-.2a2.352,2.352,0,0,1,4.7,0v.106A1.956,1.956,0,0,0,20.1,5.346l.071-.071A2.353,2.353,0,1,1,23.5,8.6l-.071.071a1.94,1.94,0,0,0-.388,2.14v.094a1.94,1.94,0,0,0,1.776,1.176h.2a2.352,2.352,0,0,1,0,4.7h-.106a1.94,1.94,0,0,0-1.776,1.176Z",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.27515101.svg";
export { ForwardRef as ReactComponent };